import { render, staticRenderFns } from "./BaseWishlistHeart.vue?vue&type=template&id=11f39fba&"
import script from "./BaseWishlistHeart.vue?vue&type=script&lang=js&"
export * from "./BaseWishlistHeart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f39fba')) {
      api.createRecord('11f39fba', component.options)
    } else {
      api.reload('11f39fba', component.options)
    }
    module.hot.accept("./BaseWishlistHeart.vue?vue&type=template&id=11f39fba&", function () {
      api.rerender('11f39fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseWishlistHeart.vue"
export default component.exports